import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { GlobalErrorHandlerService } from './global-error-handler.service';

import { SchedulingType } from '../scheduling-type/scheduling-type';

const httpOptions = {
  headers: new HttpHeaders({'Content-Type': 'application/json'})
};

@Injectable({
  providedIn: 'root'
})
export class SchedulingTypeService {
  private schedulingTypesUrl = '/api/scheduling_types';

  constructor(
    private http: HttpClient,
    private errorHandler: GlobalErrorHandlerService
  ) { }

  getAll(): Observable<SchedulingType[]> {
    return this.http
      .get<SchedulingType[]>(this.schedulingTypesUrl, httpOptions)
      .pipe(catchError(error => this.errorHandler.handleError(error)));
  }
}
